import React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import "../css/project.css";
import Typography from '@mui/material/Typography';
import { CardActions } from '@mui/material';
import Button from '@mui/material/Button';
export default function ProjectFrameVideo({title,date,src,body,link}){
    return (
        <Card sx={{ maxWidth: 345 }}>
        <CardHeader
          title={title}
          subheader={date}
        />
        <iframe src={src} allowfullscreen title={title}></iframe>
        <CardContent>
          <Typography variant="body2" color="text.secondary">
           {body}
          </Typography>
          <CardActions>
          <Button variant="text" onClick={()=>window.open(link,"_blank")}>View</Button>
          </CardActions>
        </CardContent>
      </Card>
    );
}